import { GoogleIcon } from '@nesso/ui/icons/simple-icons-google';
import { Button } from '@nesso/ui/primitives/button';

import { appConfig } from '@/shared/config/app-config';

type Props = {
    role: string;
    returnUrl?: string;
    label?: string;
    disabled?: boolean;
    signUpData?: string;
};

export function ContinueWithGoogle({
    role,
    returnUrl,
    label = 'Continue with Google',
    disabled,
    signUpData,
}: Props) {
    const redirectToGoogle = () => {
        const encodedReturnUrl = encodeURIComponent(returnUrl || appConfig.notesAppUrl);
        const signUpDataParam = signUpData ? `&signUpData=${encodeURIComponent(signUpData)}` : '';
        window.location.href = `${appConfig.apiUrl}/auth/sign-in?role=${role}&returnUrl=${encodedReturnUrl}${signUpDataParam}`;
    };

    return (
        <Button
            variant="outline"
            size="lg"
            className="w-full"
            disabled={disabled}
            onClick={redirectToGoogle}
        >
            <GoogleIcon size={20} />
            {label}
        </Button>
    );
}
